import { Component, ElementRef, inject, input, output } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaTableColumnDirective, PrivaTableComponent, PrivaTableRowEvent } from '@priva/components/table';
import { PrivaTitleComponent } from '@priva/components/title';
import { PrivaLocalizationModule } from '@priva/localization';

import { EmployeeSortInGroupPipe } from 'app/shared/features/employee-selector/components/employee-group/employee-sort-in-group.pipe';
import { updatingMultiUserRecentEmployeeNumber } from 'app/state/multi-user-preferences/multi-user-preferences.actions';

import { filterResultGroupName, promotedGroupName } from '../../constants';
import { Employee, EmployeeGroup } from '../../models';

@Component({
    selector: 'app-employee-group',
    templateUrl: './employee-group.component.html',
    styleUrl: './employee-group.component.scss',
    imports: [
        PrivaTableComponent,
        PrivaTitleComponent,
        PrivaLocalizationModule,
        EmployeeSortInGroupPipe,
        PrivaTableColumnDirective,
    ],
})
export class EmployeeGroupComponent {
    elementRef = inject(ElementRef);
    private store = inject(Store);

    employeeGroup = input<EmployeeGroup>({ groupName: '', employees: [] });

    employeeSelected = output<Employee>();
    groupTitleClicked = output<string>();

    get iconClass() {
        return this.employeeGroup().groupName === promotedGroupName
            ? 'fas fa-clock'
            : this.employeeGroup().groupName === filterResultGroupName
              ? 'fas fa-search'
              : 'fas fa-users';
    }

    onTableRowClick(event: PrivaTableRowEvent<Employee>) {
        const employee = event.row;
        this.store.dispatch(updatingMultiUserRecentEmployeeNumber({ employeeNumber: employee.number }));
        this.employeeSelected.emit(employee);
    }

    onGroupTitleClicked() {
        this.groupTitleClicked.emit(this.employeeGroup().groupName);
    }

    protected readonly promotedGroupName = promotedGroupName;
}
